import {
  correctColor,
  fixOptions,
  NumberToLetter,
} from "../../constants/Constants";
import Latex from "react-latex-next";
import React from "react";
import Div from "../../components/common/Div";
import { Tex } from "react-tex";
import Image from "../../components/common/Image";

export default function M_Order(props) {
  const question = props.question;
  const options = question.options;

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;
      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",
                fontSize: "0.9rem",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                {texCon}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function sortElements() {
    var textEl = [];

    textEl = options.sort((a, b) => (a.text > b.text ? 1 : -1));

    var sortedList = [];

    for (var x = 0; x < textEl.length; x++) {
      var el = (
        <div
          style={{
            width: "10%",
            backgroundColor: correctColor(),
            margin: "3px",
          }}
        >
          <text>{NumberToLetter(x)}</text>
        </div>
      );

      sortedList[x] = el;
    }

    return sortedList;
  }

  return (
    <text>
      <div>
        {Options()}
        {sortElements()}
      </div>
    </text>
  );
}
